import type { Control, FieldErrors } from "react-hook-form";

import type { AssessmentElement } from "@/core/types";

import {
  adaptCheckboxOptions,
  adaptRadiogroupOptions,
  adaptRatingOptions,
} from "../helpers/input-adapters";

import { MultipleChoiceQuestion } from "./MultipleChoiceQuestion";
import { RatingQuestion } from "./RatingQuestion";
import { SingleChoiceQuestion } from "./SingleChoiceQuestion";

type QuestionRendererProps = {
  control: Control;
  errors: FieldErrors;
  questions: AssessmentElement[];
};

export function QuestionRenderer({ control, errors, questions }: QuestionRendererProps) {
  const totalQuestions = questions.length;

  return (
    <div className="tw:flex tw:flex-col tw:gap-6">
      {questions.map((question, index) => {
        const questionNumber = `${index + 1}/${totalQuestions}`;

        const commonProps = {
          control,
          errors,
          key: question.name,
          label: question.title,
          name: question.name,
          questionNumber,
        };

        switch (question.type) {
          case "checkbox":
            return (
              <MultipleChoiceQuestion
                {...commonProps}
                options={adaptCheckboxOptions(question.choices)}
              />
            );

          case "radiogroup":
            return (
              <SingleChoiceQuestion
                {...commonProps}
                options={adaptRadiogroupOptions(question.choices)}
              />
            );

          case "rating":
            return (
              <RatingQuestion {...commonProps} options={adaptRatingOptions(question.rateValues)} />
            );

          default:
            return null;
        }
      })}
    </div>
  );
}
